class MediaScrollIndicator extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    const options = {
      rootMargin: `0px 0px -${window.innerHeight}px 0px`,
    }

    const callback = entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.els.indicator.elements[
            Number(entry.target.dataset.indexMedia)
          ]?.classList.add('prd-ScrollIndicator_Dot-active')
        } else {
          this.els.indicator.elements[
            Number(entry.target.dataset.indexMedia)
          ]?.classList.remove('prd-ScrollIndicator_Dot-active')
        }
      })
    }
    // eslint-disable-next-line compat/compat
    const observer = new IntersectionObserver(callback.bind(this), options)

    this.externalEls.media.elements.forEach(media => observer.observe(media))
  }
}

if (!customElements.get('media-scroll-indicator')) {
  customElements.define('media-scroll-indicator', MediaScrollIndicator)
}
